import { Badge, Avatar, Dropdown, List, Typography, notification } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { use, useContext, useEffect, useState } from "react";
import { UserContext } from "../../../context/UserContext";
import {
  getNotifications,
  markNotificationAsRead,
} from "../../../utils/api-lists/notifications.api";
import { useNavigate } from "react-router-dom";
import NotificationList from "./notification-list.components";
import { getPdfReportByPatient } from "../../../utils/api-lists/patient.api";

const { Text } = Typography;

const BellNotification = () => {
  const [notifications, setNotifications] = useState([]);
  const [visibleDropdown, setVisibleDropdown] = useState(false);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  // Normalize notifications for child
  const prepareNotifications = async (rawNotifications) => {
    const prepared = await Promise.all(
      rawNotifications
        .filter((n) => !n.is_read)
        .map(async (n) => {
          if (n.reference_type === "pdf_upload") {
            // fetch PDF info here
            const message = n.message;
            const patient_id = message.match(/patient_id=([^\s]+)/)?.[1];
            const path = message.match(/path=(.+)$/)?.[1];

            let pdfUrl = null;
            if (patient_id && path) {
              const patient_pdf = await getPdfReportByPatient(patient_id);
              const pdf = patient_pdf.pdf_reports.find((pdf) => pdf.path === path);
              pdfUrl = pdf?.url || null;
            }

            return {
              id: n.id,
              type: "pdf_upload",
              messageText: message.split("|")[0],
              patient_id,
              pdfUrl,
            };
          } else if (n.reference_type === "report") {
            return {
              id: n.id,
              type: "report",
              messageText: n.message.split("|")[0],
              patient_id: n.patient_id,
              reference_id: n.reference_id,
            };
          }

          // fallback for any other type
          return {
            id: n.id,
            type: n.reference_type,
            messageText: n.message,
          };
        })
    );

    return prepared;
  };

  const handleNotificationClick = async (notification) => {
    
    if (notification.type === "report") {
      navigate(
        `/patient-cabinet/${notification.patient_id}/skin-report/${notification.reference_id}`
      );
    }else if (notification.type === "pdf_upload" && notification.pdfUrl) {  
      window.open(notification.pdfUrl, "_blank");
    }

    await markNotificationAsRead(user.id, notification.id);
    setVisibleDropdown(false)

      setNotifications((prev) =>
        prev
          .map((n) => {
            if (n.id === notification.id) {
              return { ...n, is_read: true };
            }
            return n;
          })
          .filter((n) => !n.is_read)
      );
    
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await getNotifications(user.id);
        const prepared = await prepareNotifications(response.notifications);        
        setNotifications(prepared);
      } catch (error) {
        notification.error({
          message: "Error fetching notifications",
          description: error.message,
        });
      }
    };
    
    fetchNotifications();

    const intervalId = setInterval(fetchNotifications, 60 * 1000); // every 1 minute

    return () => clearInterval(intervalId); // cleanup on unmount
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        marginRight: "10px",
      }}
    >
      <Dropdown
        placement="bottom"
        open={visibleDropdown}
        onOpenChange={(visible) => setVisibleDropdown(visible)}
        dropdownRender={() => (
          <NotificationList
            notifications={notifications}
            onNotificationClick={handleNotificationClick}
          />
        )}
        trigger={["click"]}
        locale={{ emptyText: "You're all caught up!" }}
      >
        <Badge count={notifications.length} size="small" offset={[-2, 2]}>
          <Avatar
            shape="circle"
            icon={<BellOutlined />}
            style={{ backgroundColor: "#f0f2f5", color: "#555" }}
          />
        </Badge>
      </Dropdown>
    </div>
  );
};

export default BellNotification;
